
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","d":"M0 0h14v14H0z"}}),_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.3","d":"M13.35 11v1.15a1.2 1.2 0 01-1.2 1.2H11v0m-8 0H1.85a1.2 1.2 0 01-1.2-1.2V11v0m0-8V1.85a1.2 1.2 0 011.2-1.2H3v0m8 0h1.15a1.2 1.2 0 011.2 1.2V3M3.585 4.998L7 6.95l3.409-1.948M7 6.95v4.3m.252.103l3.474-2.03a.25.25 0 00.124-.216v-4.07a.5.5 0 00-.248-.432l-3.35-1.958a.5.5 0 00-.504 0l-3.35 1.958a.5.5 0 00-.248.432v4.07a.25.25 0 00.124.215l3.474 2.03a.5.5 0 00.504 0z"}})])
          )
        }
      }
    